export const siteSettings = {
  name: "Trade Sphere",
  link: "https://tradespherepro.com",
  email: "support@tradespherepro.com",
  appLink: "https://app.tradespherepro.com",
};
